export const LOGIN = "LOGIN";
export const APPROVE = "APPROVE";
export const REGISTER = "REGISTER";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const SEND_BVN = "SEND_BVN";
export const VERIFY_BVN = "VERIFY_BVN";
export const CREATE_PIN = "CREATE_PIN";
export const SEND_PASS_OTP = "SEND_PASS_OTP";
export const VERIFY_PASS_OTP = "VERIFY_PASS_OTP";
export const UPDATE_PASS = "UPDATE_PASS";
export const SEND_EMAIL_TOKEN = "SEND_EMAIL_TOKEN";
export const CREATE_SIGN = "CREATE_SIGN";
export const CREATE_BUSINESS = "CREATE_BUSINESS";
export const TRANSFER = "TRANSFER";
export const VALIDATE_BANK = "VALIDATE_BANK";
export const ACC_BALANCE = "ACC_BALANCE";
export const GET_FLOW = "GET_FLOW";
export const BANK_CODE = "BANK_CODE";
export const TRANSACTION = "TRANSACTION";
export const GET_PAYMENT = "GET_PAYMENT";
export const GET_APP_PAYMENT = "GET_APP_PAYMENT";
export const TRANSACTIONS = "TRANSACTIONS";
export const GET_DEBIT = "GET_DEBIT";
export const GET_SIGNATORIES = "GET_SIGNATORIES";
export const GET_CREDIT = "GET_CREDIT";
export const GET_BENE = "GET_BENE";
export const GET_USER = "GET_USER";
